import React, { useEffect, useState, useRef } from "react";
import { Icon } from "@iconify/react";
import { Button } from "../../../components/ui/button";
import { Card, CardHeader, CardContent } from "../../../components/ui/card";
import POSReceipt from "../../../components/print/POSReceipt";
import Common from "../../../helper/common";
import {
  PaymentTypeEnum,
  PaymentStatusEnum,
  SaleOrderStatusEnum,
  respEnum,
  TransactionLogStatusEnum,
  TransactionLogTypeEnum,
  ImageFolderEnum,
  AppUserSettingsTypeEnum,
  AttachmentHistoryLogTypeEnum,
  IntMinLevel,
  IntMax
} from "../../../constants/appConstant";
import { useNavigate, useSearchParams } from "react-router-dom";
import toast from "react-hot-toast";
import { Formik } from "formik";
import { FormikTextArea, FormikInput, FormikSearchSectionSelect, FormikSingleFileUpload } from "../../../components/formik-components";
import DialogModal from "../../../components/partials/modal/dialogModal";
import PrintReceipt from "../../../components/print/PrintReceipt";
import * as yup from "yup";
import moment from "moment";
import Utility from "../../../helper/utilityHelper";
import AdvanceTable from "../../../components/advanceTable";
import common from "../../../helper/common";
import { FaRedo } from "react-icons/fa";
import { FaEye } from "react-icons/fa";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../../../components/ui/tabs";
// Form validation schema
const formValidations = yup.object().shape({
  clubAccountId: yup.mixed().required("Payment Account is required"),
  amount: yup
    .number()
    .required("Amount is required")
    .min(1, "Amount must be greater than 0"),
});

const POSOrderDetails = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const [cancelBtn, setCancelBtn] = useState(false);
  const [isCancelled, setIsCancelled] = useState(false);
  const [showAddPayment, setShowAddPayment] = useState(false);
  const [showAddDiscount, setShowAddDiscount] = useState(false);
  const [isAddingDiscount, setIsAddingDiscount] = useState(false);



  const [paymentTypeList, setPaymentTypeList] = useState([]);
  const [modalContent, setModalContent] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [transactionLogs, setTransactionLogs] = useState([]);
  const orderId = searchParams.get("id");
  const shouldPrint = searchParams.get("print") === "true";
  const [order, setOrder] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  // temporary hiding discount details table
  const [showDiscountDetails, setShowDiscountDetails] = useState(false);
  const printRef = useRef();


  const [showLogModal, setShowLogModal] = useState(false);
  const [selectedLog, setSelectedLog] = useState(null);

  const handleSeeLog = (log) => {
    setSelectedLog(log);
    setShowLogModal(true);
  };

  const _renderViewLogs = ({ logs, onClose }) => {
    const columns = [
      { title: "Reason", key: "changing_reason" },
      {
        title: "Previous Receipt", type: "image", key: "previous_receipt"
        , render: (_, record) => (
          <div className="flex justify-center">
            <img
              src={Utility.getImagePath(record?.previous_receipt?.path)}
              alt={record?.previous_receipt?.title || "Previous Receipt"}
              className="w-24 h-24 object-cover rounded-lg border cursor-pointer hover:opacity-80 transition-opacity"
              onClick={() => handleImageClick(record?.previous_receipt?.path)}
            />
          </div>
        ),
      },
      {
        title: "New Receipt", key: "new_receipt", type: "image"
        , render: (_, record) => (
          <div className="flex justify-center">
            <img
              src={Utility.getImagePath(record?.new_receipt?.path)}
              alt={record?.new_receipt?.title || "New Receipt"}
              className="w-24 h-24 object-cover rounded-lg border cursor-pointer hover:opacity-80 transition-opacity"
              onClick={() => handleImageClick(record?.new_receipt?.path)}
            />
          </div>
        ),
      },
      {
        title: "Add At",
        key: "createdOn",
        type: "text",
        render: (row) => Common.Utility.ConvertDate(row.createdOn)
      }
    ];

    return (
      <div className="max-h-[80vh] overflow-y-auto">
        <div className="mb-6">
          <h3 className="font-bold text-center text-xl text-gray-800 mb-2">Receipt Changing Logs</h3>
          <p className="text-center text-sm text-gray-600">History of receipt changes for this transaction</p>
        </div>

        {logs && logs.length > 0 ? (
          <div className="overflow-x-auto">
            <AdvanceTable
              data={{ data: logs }}
              columns={columns}
            />
          </div>
        ) : (
          <div className="text-center py-8">
            <p className="text-gray-500">No receipt change logs found</p>
          </div>
        )}

        <div className="mt-6 text-right">
          <Button type="button" variant="outline" onClick={() => onClose(null)}>
            Close
          </Button>
        </div>
      </div>
    );
  };


  const [showUpdateReceipt, setShowUpdateReceipt] = useState(false);
  const [updateReceiptData, setUpdateReceiptData] = useState({
    id: null,
    type: null,
    previous_receipt: null,
  });


  const handleUpdateReceipt = (transactionLog) => {
    setUpdateReceiptData({
      id: transactionLog.id,
      type: AttachmentHistoryLogTypeEnum.Pos_Payment,
      previous_receipt: transactionLog.attachment,
    });
    setShowUpdateReceipt(true);
  };
   const _renderUpdateReceipt = ({ type, id, previous_receipt, onClose }) => {
      const [isSubmitting, setIsSubmitting] = useState(false);
  
      return (
        <div className="modal-scroll-container">
          <Formik
            initialValues={{
              attachment: previous_receipt || null,
              new_receipt: null,
              changing_reason: "",
              type: type || null,
            }}
            validationSchema={yup.object({
              changing_reason: yup
                .string()
                .required("Reason is required")
                .min(3, "Reason must be at least 3 characters")
                .max(200, "Reason must be less than 200 characters")
            })}
  
            validateOnChange={false}
            validateOnBlur={false}
            onSubmit={async (values, action) => {
              if (isSubmitting) return; // Prevent multiple submissions
  
              setIsSubmitting(true);
  
              let data = {
                ...values,
                transaction_log_id: id,
                type,
                previous_receipt: values.attachment,
                new_receipt: null,
                changing_reason: values.changing_reason,
              };
  
              const imagePath = data.files?.[0]?.path;
              if (imagePath) {
                data.new_receipt = imagePath;
              }
              if (!data.changing_reason || data.changing_reason.trim() === '') {
                toast.error(`Please enter a reason for changing the receipt`);
                setIsSubmitting(false);
                action.setSubmitting(false);
                return;
              }
  
              if (!data.new_receipt) {
                toast.error(`Please upload a new receipt image`);
                setIsSubmitting(false);
                action.setSubmitting(false);
                return;
              }
  
              if (data.files && data.files.filter((item) => !item.imageUrl).length) {
                var uploadFilePathType = ImageFolderEnum.transactions;
                data.new_receipt = (
                  await Common.Utility.handleFileUpload(data.files, uploadFilePathType)
                )[0].photo;
                data.files = null;
              } else if (data.attachment) {
                data.new_receipt = data.attachment;
              }
  


              let response = await Common.ApiService.getInstance().request(
                "ChangeAttachment",
                data,
                "POST"
              );
  
              setIsSubmitting(false);
              action.setSubmitting(false);
              debugger
              if (response.status === respEnum.Success) {
                if (onClose) {
                  onClose(response.data);
                }
  
                common.SweetAlert.alert(response.message, "success");
  
                 setTimeout(() => {
                     loadOrderDetails();
                  }, 500);
              }
            }}
          >
            {(formikProps) => (
              <>
                <div className="flex flex-col gap-2">
                  <FormikSingleFileUpload
                    formikProps={formikProps}
                    title="Previous Image"
                    uploadMainTxt="Upload Image"
                    uploadTxt="Max size 2 MB"
                    name="attachment"
                    viewOnly={true}
                  />
                </div>
  
                <div className="flex flex-col gap-2 mt-3">
                  <FormikInput
                    formikProps={formikProps}
                    name="changing_reason"
                    label="Changing Reason"
                    placeholder="Type Reason"
                    maxLength="200"
                  />
                </div>
  
  
                <div className="flex flex-col gap-2 mt-3">
                  <FormikSingleFileUpload
                    formikProps={formikProps}
                    title="Upload New Receipt"
                    uploadMainTxt="Upload New Receipt"
                    uploadTxt="Max size 2 MB"
                    name="new_receipt"
                  />
                </div>
  
                <div className="mt-5 text-right flex gap-2 justify-end">
                  <Button
                    type="button"
                    variant="primary"
                    onClick={() => formikProps.handleSubmit()}
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? (
                      <>
                        <Icon icon="eos-icons:loading" className="w-4 h-4 mr-2" />
                        Updating...
                      </>
                    ) : (
                      "Update"
                    )}
                  </Button>
  
                  <Button
                    type="button"
                    variant="outline"
                    onClick={() => onClose(null)}
                    disabled={isSubmitting}
                  >
                    Close
                  </Button>
                </div>
              </>
            )}
          </Formik>
        </div>
      );
    };


  useEffect(() => {
    if (orderId) {
      loadOrderDetails();
      // loadPaymentTypes();
      getClubPaymentTypes();
    }
  }, [orderId]);

  useEffect(() => {
    if (shouldPrint && order && printRef.current) {
      // Auto-print when the component loads with print=true
      setTimeout(() => {
        try {
          if (printRef.current && printRef.current.print) {
            printRef.current.print();
          }
        } catch (error) {
          console.error("Auto-print failed:", error);
          toast.error("Auto-print failed. Please try printing manually.");
        }
      }, 2000);
    }
  }, [shouldPrint, order]);

  const loadOrderDetails = async () => {
    try {
      setIsLoading(true);
      const response = await Common.ApiService.getInstance().request(
        `GetSaleOrderById?id=${orderId}`,
        null,
        "GET"
      );

      if (response?.status === respEnum.Success && response.data) {
        setOrder(response.data);
        // Set transaction logs from the order data
        setTransactionLogs(response.data.transactionLogs || []);
      } else {
        toast.error("Order not found");
        navigate("/app/pos-orders");
      }
    } catch (error) {
      console.error("Error loading order details:", error);
      toast.error("Failed to load order details");
      navigate("/app/pos-orders");
    } finally {
      setIsLoading(false);
    }
  };

  // const loadPaymentTypes = async () => {
  //   try {
  //     const response = await Common.ApiService.getInstance().request(
  //       "GetClubAccounts",
  //       null,
  //       "GET"
  //     );

  //     if (response?.status === respEnum.Success && response.data) {
  //       setPaymentTypeList(response.data);
  //     }
  //   } catch (error) {
  //     console.error("Error loading payment types:", error);
  //   }
  // };

  const getClubPaymentTypes = async () => {
    const response = await Common.ApiService.getInstance().request(
      "GetClubPaymentTypes"
    );

    if (response?.status == respEnum.Success) {
      setPaymentTypeList(response?.data ?? []);
    }
  };

  // loadTransactionLogs function removed - now using transactionLogs from GetSaleOrderById response

  const AddPayment = async (values) => {
    try {
      let data = {
        order_id: order.id,
        club_account_id: parseInt(values.clubAccountId?.value),
        customer_id: order.customer_id,
        received_amount: values.amount,
      };

      // Handle file upload if attachment exists
      if (values.files && values.files.length > 0 && values.files[0] instanceof File) {
        const uploadFilePathType = ImageFolderEnum.transactions;
        const uploadedFiles = await Common.Utility.handleFileUpload(values.files, uploadFilePathType);
        data.attachment = uploadedFiles[0].photo;
      }
      console.log(data, 'payment data');
      const response = await Common.ApiService.getInstance().request(
        "AddSaleOrderPayment",
        data,
        "POST"
      );

      if (response?.status === respEnum.Success) {
        toast.success("Payment added successfully!");
        setShowAddPayment(false);
        await loadOrderDetails(); // This will also update transactionLogs
      } else {
        toast.error(response?.message || "Failed to add payment");
      }
    } catch (error) {
      console.error("Error adding payment:", error);
      toast.error("Failed to add payment");
    }
  };

  const handlePrint = () => {
    if (printRef.current && printRef.current.print) {
      printRef.current.print();
    }
  };

  // const formatDate = (date) => {
  //   const options = { year: "numeric", month: "long", day: "numeric" };
  //   return new Date(date).toLocaleDateString("en-US", options);
  // };

  const handleImageClick = (attachment) => {
    setModalContent(
      <img
        src={Common.Utility.getImagePath(attachment)}
        alt="Attachment"
        className="w-1/2 h-1/2 object-contain"
        style={{ width: "50%", height: "50%" }}
      />
    );
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleCancelOrder = async (id, cancelReason) => {
    try {
      let response = await Common.ApiService.getInstance().request(
        `CancelSaleOrder?id=${id}&cancelReason=${encodeURIComponent(
          cancelReason
        )}`,
        {},
        "POST"
      );

      setCancelBtn(false);
      await loadOrderDetails();
      setIsCancelled(true);

      if (response?.status === respEnum.Success) {
        Common.SweetAlert.success("Order cancelled successfully!!!!!");
      } else {
        Common.SweetAlert.error(response?.message || "Failed to cancel order.");
      }
    } catch (err) {
      Common.SweetAlert.error(
        "Something went wrong while cancelling the order."
      );
      console.error(err);
    }
  };


  const dynamicDiscountValidation = yup.object().shape({
    discount: yup
      .number()
      .required("Enter Discount")
      .min(IntMinLevel, "Discount can't be negative or zero")
      .max(
        order?.remaining_amount,
        `Discount must be less than ${order?.remaining_amount}`
      )
      .test(
        "is-integer",
        "Please enter a whole number without decimal points",
        (value) => Number.isInteger(value)
      ),
    clubbankdiscountid: yup.number().when("discountTab", {
      is: "card",
      then: (schema) => schema.required("Bank selection is required"),
      otherwise: (schema) => schema.nullable(),
    }),
    discountTab: yup.string(),
    discountType: yup.string(),
    percentage: yup.string(),
  });

const AddDiscount = async (d) => {
  if (isAddingDiscount) return; // Prevent multiple submissions
  setIsAddingDiscount(true);

  try {
    let resp;

    // Prepare request payload
    let data = {
      ...d,
      order_id: order?.id,
      discount: +d.discount,
    };

    // Validation: discount must not exceed remaining amount
    if (order?.remaining_amount < data.discount) {
      toast.error(`Discount must be less than ${order?.remaining_amount} Rs`);
      return;
    }

    // File handling
    if (d.files && d.files.filter((item) => !item.imageUrl).length) {
      const uploadFilePathType = ImageFolderEnum.transactions;
      data.receipt = (
        await Common.Utility.handleFileUpload(d.files, uploadFilePathType)
      )[0].photo;
      data.files = null;
    } else if (d.attachment) {
      data.receipt = d.attachment;
    }

    // API Call
    resp = await Common.ApiService.getInstance().request(
      "AddSaleOrderDiscount",
      data,
      "POST"
    );

    if (resp?.status === respEnum.Success) {
      toast.success("Discount added successfully!");
      setShowAddDiscount(false);
      await loadOrderDetails(); // Refresh data
    } else {
      toast.error(resp?.message || "Failed to add Discount");
    }
  } catch (error) {
    console.error("Error adding discount:", error);
  } finally {
    setIsAddingDiscount(false);
  }
};


  
const _renderAddDiscount = () => (
  <div>
    <Formik
      onSubmit={AddDiscount}
      validationSchema={dynamicDiscountValidation}
      enableReinitialize
      initialValues={{
        discountTab: "bank",
        discountType: "fixed",
        percentage: "",
        discount: "",
        clubbankdiscountid: "",
      }}
      validateOnChange={false}
      validateOnBlur={false}
    >
      {(formikProps) => {
        const calculateDiscountFromPercentage = (percentage) => {
          if (percentage && order?.courtcharges) {
            return Math.round((order.courtcharges * percentage) / 100);
          }
          return "";
        };

        return (
          <>
            {/* Tabs */}
            <div className="mt-4">
              <Tabs
                defaultValue="bank"
                value={formikProps.values.discountTab || "bank"}
                onValueChange={(value) => {
                  formikProps.setFieldValue("discountTab", value);
                  formikProps.setFieldValue("discountType", "fixed");
                  formikProps.setFieldValue("discount", "");
                  formikProps.setFieldValue("percentage", "");
                  formikProps.setFieldValue("clubbankdiscountid", "");
                }}
                className="mb-2"
              >
                {/* <TabsList className="grid w-full grid-cols-2 bg-gray-100 p-1 rounded-lg">
                  <TabsTrigger
                    value="bank"
                    className="data-[state=active]:bg-white data-[state=active]:text-blue-600 data-[state=active]:shadow-sm transition-all duration-200"
                  >
                    <Icon icon="mdi:discount" className="w-4 h-4 mr-2" />
                    Club Discount
                  </TabsTrigger>
                </TabsList> */}

                {/* Club Discount Tab */}
                <TabsContent value="bank">
                  <div className="space-y-4">

                    
                    
                    {/* Charges Info */}
                    <div className="mt-4">
                      <div className="p-3 bg-blue-50 border border-blue-200 rounded-md mb-3">
                        <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-2">
                          <p className="text-sm text-blue-800 font-medium">
                            Product Charges: Rs. {order?.total_amount || 0} {/* product charges .. */}
                          </p>
                          <p className="text-sm text-blue-800 font-medium">
                            Remaining Amount: Rs. {order?.remaining_amount || 0}
                          </p>
                        </div>
                      </div>

                      {/* Fixed */}
                      {formikProps.values.discountType === "fixed" && (
                        <FormikInput
                          formikProps={formikProps}
                          name={"discount"}
                          placeholder={"Enter Amount"}
                          label={"Discount Amount"}
                          type={"number"}
                          max={IntMax}
                          min={IntMinLevel}
                          onChange={(value) => {
                            if (value < IntMinLevel && value !== "") {
                              formikProps.setFieldValue("discount", IntMinLevel);
                            } else {
                              formikProps.setFieldValue("discount", value);
                            }
                          }}
                        />
                      )}

                      
                    </div>
                  </div>
                </TabsContent>
              </Tabs>
            </div>

            {/* File Upload */}
            <div className="flex flex-col gap-2 mt-3">
              <FormikSingleFileUpload
                formikProps={formikProps}
                uploadMainTxt="Upload Receipt (Optional)"
                uploadTxt="Max size 2mb"
                name="attachment"
                height={100}
              />
            </div>

            {/* Action Buttons */}
              <div style={{ marginTop: "20px", textAlign: "right" }}>
                <Button
                  color="success"
                  onClick={(e) => {
                    e.preventDefault();
                    formikProps.handleSubmit();
                  }}
                  className="shadow-md mr-3"
                  disabled={isAddingDiscount}
                >
                  {isAddingDiscount ? (
                    <>
                      <Icon
                        icon="eos-icons:loading"
                        className="w-4 h-4 mr-2"
                      />
                      Processing...
                    </>
                  ) : (
                    <>
                      <Icon icon="heroicons:ticket" className="w-4 h-4 mr-2" />
                      Add Discount
                    </>
                  )}
                </Button>

                <Button
                  color="secondary"
                  className="secondary"
                  onClick={() => setShowAddDiscount(false)}
                  disabled={isAddingDiscount}
                >
                  Close
                </Button>
              </div>
          </>
        );
      }}
    </Formik>
  </div>
);



  const _renderAddPayment = () => (
    <div>
      <Formik
        onSubmit={AddPayment}
        validationSchema={formValidations}
        initialValues={{
          clubAccountId: null,
          amount: order?.remaining_amount || 0,
        }}
        validateOnChange={false}
        validateOnBlur={false}
      >
        {(formikProps) => (
          <>
            <div className="mb-3">
              <FormikSearchSectionSelect
                formikProps={formikProps}
                name={"clubAccountId"}
                label={"Payment Account"}
                data={paymentTypeList}
              />
            </div>

            <div>
              <FormikInput
                formikProps={formikProps}
                name="amount"
                placeholder="Received Amount"
                label="Received Amount"
                type={"number"}
                min={1}
                onChange={(value) => {
                  if (value < 1 && value != "") {
                    formikProps.setFieldValue("amount", 1);
                  } else {
                    formikProps.setFieldValue("amount", value);
                  }
                }}
              />
            </div>

            <div className="flex flex-col gap-2 mt-3">
              <FormikSingleFileUpload
                formikProps={formikProps}
                uploadMainTxt="Upload Receipt"
                uploadTxt="Max size 2mb"
                name="attachment"
              />
            </div>

            <div style={{ marginTop: "20px", textAlign: "right" }}>
              <Button
                color="success"
                onClick={(e) => {
                  e.preventDefault();
                  formikProps.handleSubmit();
                }}
                className="shadow-md mr-3"
              >
                Add Payment
              </Button>

              <Button
                color="secondary"
                className="secondary"
                onClick={() => setShowAddPayment(false)}
              >
                Close
              </Button>
            </div>
          </>
        )}
      </Formik>
    </div>
  );

  const _renderCancelOrder = () => (
    <Formik
      initialValues={{ cancelReason: "" }}
      onSubmit={async (values) => {
        const reason = values.cancelReason?.trim() || null;
        await handleCancelOrder(orderId, reason);
      }}
      validateOnChange={false}
      validateOnBlur={false}
    >
      {(formikProps) => (
        <>
          <FormikTextArea
            formikProps={formikProps}
            name="cancelReason"
            placeholder="Type..."
            type="textarea"
            label="Reason (Optional)"
            maxLength={50}
          />

          <div className="flex justify-end gap-3 mt-6 pt-6 border-t border-gray-200">
            <Button
              variant="outline"
              onClick={() => setCancelBtn(false)}
              className="px-6 py-2 hover:bg-gray-50 transition-colors"
            >
              <Icon icon="heroicons:x-mark" className="w-4 h-4 mr-2" />
              Close
            </Button>
            <Button
              onClick={(e) => {
                e.preventDefault();
                formikProps.handleSubmit();
              }}
              className="px-6 py-2 bg-gradient-to-r from-red-600 to-red-700 hover:from-red-700 hover:to-red-800 text-white shadow-lg hover:shadow-xl transition-all duration-200"
            >
              <Icon icon="heroicons:x-circle" className="w-4 h-4 mr-2" />
              Cancel Order
            </Button>
          </div>
        </>
      )}
    </Formik>
  );

  const getPaymentStatusDisplay = (status) => {
    switch (status) {
      case PaymentStatusEnum.Paid:
        return {
          label: "Paid",
          className: "bg-green-100 text-green-800",
        };
      case PaymentStatusEnum.Partial_Paid:
        return {
          label: "Partial Paid",
          className: "bg-yellow-100 text-yellow-800",
        };
      case PaymentStatusEnum.Un_Paid:
        return {
          label: "Unpaid",
          className: "bg-red-100 text-red-800",
        };
      default:
        return {
          label: "Unknown",
          className: "bg-gray-100 text-gray-800",
        };
    }
  };

  const getOrderStatusDisplay = (status) => {
    switch (status) {
      case SaleOrderStatusEnum.Confirmed:
        return {
          label: "Confirmed",
          className: "bg-green-100 text-green-800",
        };
      case SaleOrderStatusEnum.Pending:
        return {
          label: "Pending",
          className: "bg-yellow-100 text-yellow-800",
        };
      case SaleOrderStatusEnum.Cancelled:
        return {
          label: "Cancelled",
          className: "bg-red-100 text-red-800",
        };
      default:
        return {
          label: "Unknown",
          className: "bg-gray-100 text-gray-800",
        };
    }
  };

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-[#2E55B9]"></div>
          <p className="mt-4 text-lg font-medium text-gray-600">
            Loading Order Details...
          </p>
        </div>
      </div>
    );
  }

  if (!order) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center">
        <div className="text-center">
          <Icon
            icon="heroicons:exclamation-triangle"
            className="h-16 w-16 text-red-500 mx-auto mb-4"
          />
          <p className="text-lg font-medium text-gray-600">Order not found</p>
        </div>
      </div>
    );
  }

  const paymentStatus = getPaymentStatusDisplay(order.payment_status);
  const orderStatus = getOrderStatusDisplay(order.status);

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 p-6">
      {/* Header */}
      <div className="mb-6">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
          <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:gap-4">
            <div className="flex flex-col gap-3 sm:flex-row">
              <Button
                variant="outline"
                size="sm"
                // onClick={() => navigate("/app/pos")}
                onClick={() => navigate(-1)}
                className="bg-white shadow-md hover:shadow-lg transition-shadow"
              >
                <Icon icon="heroicons:arrow-left" className="h-4 w-4 mr-2" />
                Back
              </Button>
              <Button
                variant="outline"
                size="sm"
                onClick={() => navigate("/app/pos-orders")}
                className="bg-white shadow-md hover:shadow-lg transition-shadow"
              >
                <Icon icon="heroicons:list-bullet" className="h-4 w-4 mr-2" />
                All Orders
              </Button>
            </div>
            <div>
              <h1 className="text-3xl font-bold text-gray-800 flex items-center gap-3">
                <div className="bg-[#2E55B9] p-3 rounded-full">
                  <Icon
                    icon="heroicons:receipt-percent"
                    className="text-white"
                    width={24}
                    height={24}
                  />
                </div>
                Order Details
              </h1>
              <p className="text-gray-600 text-lg mt-1">
                Order #{order.ref_no}
              </p>
            </div>
          </div>

          <div className="flex flex-col gap-3 sm:flex-row">

            {cancelBtn && (
              <DialogModal
                title={
                  <div className="flex items-center gap-3">
                    <div className="bg-red-100 p-2 rounded-lg">
                      <Icon
                        icon="heroicons:x-circle"
                        className="w-5 h-5 text-red-600"
                      />
                    </div>
                    <div>
                      <h3 className="font-semibold text-lg">Cancel Order</h3>
                      <p className="text-gray-600 text-sm">
                        Cancel this Order permanently
                      </p>
                    </div>
                  </div>
                }
                open={cancelBtn}
                setOpen={setCancelBtn}
                Child={_renderCancelOrder}
                className="max-w-md"
              />
            )}

            {showAddPayment && (
              <DialogModal
                title={
                  <div className="flex items-center gap-3">
                    <div className="bg-green-100 p-2 rounded-lg">
                      <Icon
                        icon="heroicons:credit-card"
                        className="w-5 h-5 text-green-600"
                      />
                    </div>
                    <div>
                      <h3 className="font-semibold text-lg">Add Payment</h3>
                      <p className="text-gray-600 text-sm">
                        Process a new payment for this order
                      </p>
                    </div>
                  </div>
                }
                open={showAddPayment}
                setOpen={setShowAddPayment}
                Child={_renderAddPayment}
                className="max-w-2xl"
              />
            )}
            {/* Add Payment button - only show when order is not paid */}
            {order?.is_paid === false && order?.cancelled_by == null && (
              <Button
                className="bg-blue-600 hover:bg-blue-700 shadow-lg hover:shadow-xl transition-all"
                onClick={() => setShowAddPayment(true)}
              >
                <Icon
                  icon="heroicons:credit-card"
                  className="h-4 w-4 mr-2"
                />
                Add Payment
              </Button>
            )}


            {/* Add Discount*/}
            {showAddDiscount && (
              <DialogModal
                title={
                  <div className="flex items-center gap-3">
                    <div className="bg-green-100 p-2 rounded-lg">
                      <Icon
                        icon="heroicons:credit-card"
                        className="w-5 h-5 text-green-600"
                      />
                    </div>
                    <div>
                      <h3 className="font-semibold text-lg">Add Discount</h3>
                      <p className="text-gray-600 text-sm">
                        Process a new discount for this order
                      </p>
                    </div>
                  </div>
                }
                open={showAddDiscount}
                setOpen={setShowAddDiscount}
                Child={_renderAddDiscount}
                className="max-w-2xl"
              />
            )}
            {/* Add Disount button - only show when order is not paid */}
            {order?.is_paid === false && order?.cancelled_by == null && (
              <Button
                className="bg-yellow-600 hover:bg-yellow-700 shadow-lg hover:shadow-xl transition-all"
                onClick={() => setShowAddDiscount(true)}
              >
                <Icon
                  icon="heroicons:credit-card"
                  className="h-4 w-4 mr-2"
                />
                Add Discount
              </Button>
            )}









            {/* cancel btn hide after 48h */}
            {order?.cancelled_by == null &&
              Common.Utility.ShowOnValidateDateOperation(
                order,
                "createdon",
                ">=",
                true,
                global.user.appUserSettings?.find(setting => setting.type === AppUserSettingsTypeEnum.POS_Cancel_Order)?.value || 48
              ) && (
                <Button
                  className="bg-red-600 hover:bg-red-700 shadow-lg hover:shadow-xl transition-all"
                  color="destructive"
                  onClick={async () => {
                    const isConfirmed = await Common.SweetAlert.confirmation(
                      "Are you sure you want to cancel this Order? This can't be reversed!",
                      "Confirm Cancel"
                    );
                    if (isConfirmed) {
                      setCancelBtn(true);
                    }
                  }}
                >
                  <Icon
                    icon="heroicons-solid:x-mark"
                    className="h-4 w-4 mr-2"
                  />
                  Cancel Order
                </Button>
              )}

            {order?.cancelled_by == null && (
              <Button
                size="sm"
                onClick={handlePrint}
                className="bg-green-600 hover:bg-green-700 shadow-lg hover:shadow-xl transition-all"
              >
                <Icon icon="heroicons:printer" className="h-4 w-4 mr-2" />
                Print Receipt
              </Button>
            )}
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 xl:grid-cols-4 gap-6">
        {/* Main Content */}
        <div className="xl:col-span-3 space-y-6">
          {/* Order Information */}
          <Card className="shadow-xl border-0">
            <CardHeader className="bg-gradient-to-r from-[#2E55B9] to-[#4A73D6] text-white rounded-t-lg">
              <h2 className="text-lg font-semibold flex items-center gap-2">
                <Icon
                  icon="heroicons:information-circle"
                  width={20}
                  height={20}
                />
                Order Information
              </h2>
            </CardHeader>
            <CardContent className="p-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="space-y-4">
                  <div className="bg-gray-50 p-4 rounded-lg">
                    <p className="text-sm font-medium text-gray-600 mb-1">
                      Order Number
                    </p>
                    <p className="text-xl font-bold text-[#2E55B9]">
                      {order.ref_no}
                    </p>
                  </div>
                  <div className="bg-gray-50 p-4 rounded-lg">
                    <p className="text-sm font-medium text-gray-600 mb-1">
                      Order Date
                    </p>
                    <p className="text-lg text-gray-800">
                      {order.createdon
                        ? moment(Common.Utility.ConvertTime(order.order_date)).format("DD MMM YYYY")
                        : "N/A"}
                      {/* {formatDate(order.order_date)} */}
                    </p>
                  </div>
                  <div className="bg-gray-50 p-4 rounded-lg">
                    <p className="text-sm font-medium text-gray-600 mb-2">
                      Order Status
                    </p>
                    <span
                      className={`inline-flex items-center px-4 py-2 rounded-full text-sm font-medium ${orderStatus.className}`}
                    >
                      {orderStatus.label}
                    </span>
                  </div>
                </div>
                <div className="space-y-4">
                  <div className="bg-gray-50 p-4 rounded-lg">
                    <p className="text-sm font-medium text-gray-600 mb-1">
                      Customer
                    </p>
                    <p className="text-lg font-semibold text-gray-800">
                      {order.customerName || "Walk-in Customer"}
                    </p>
                  </div>
                  <div className="bg-gray-50 p-4 rounded-lg">
                    <p className="text-sm font-medium text-gray-600 mb-2">
                      Payment Status
                    </p>
                    <span
                      className={`inline-flex items-center px-4 py-2 rounded-full text-sm font-medium ${paymentStatus.className}`}
                    >
                      {paymentStatus.label}
                    </span>
                  </div>
                  <div className="bg-gray-50 p-4 rounded-lg">
                    <p className="text-sm font-medium text-gray-600 mb-1">
                      Created On
                    </p>
                    <p className="text-lg text-gray-800">
                      {order.createdon
                        ? Common.Utility.ConvertTime(order.createdon)
                        : "N/A"}
                    </p>
                  </div>
                  {order.note && (
                    <div className="bg-gray-50 p-4 rounded-lg">
                      <p className="text-sm font-medium text-gray-600 mb-2">
                        Notes
                      </p>
                      <p className="text-gray-800 bg-white p-3 rounded-lg border">
                        {order.note}
                      </p>
                    </div>
                  )}
                </div>
              </div>
            </CardContent>
          </Card>

          {/* Order Items */}
          <Card className="shadow-xl border-0">
            <CardHeader className="bg-gradient-to-r from-green-500 to-green-600 text-white rounded-t-lg">
              <h2 className="text-lg font-semibold flex items-center gap-2">
                <Icon icon="heroicons:shopping-bag" width={20} height={20} />
                Order Items ({order.items?.length || 0})
              </h2>
            </CardHeader>
            <CardContent className="p-0">
              <div className="overflow-x-auto">
                <table className="w-full">
                  <thead className="bg-gray-100">
                    <tr>
                      <th className="text-left p-4 font-semibold text-gray-700 border-b">
                        Product
                      </th>
                      <th className="text-center p-4 font-semibold text-gray-700 border-b">
                        Qty
                      </th>
                      <th className="text-right p-4 font-semibold text-gray-700 border-b">
                        Price
                      </th>
                      <th className="text-right p-4 font-semibold text-gray-700 border-b">
                        Total
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200">
                    {order.items?.map((item, index) => (
                      <tr
                        key={index}
                        className="hover:bg-gray-50 transition-colors"
                      >
                        <td className="p-4">
                          <div className="font-medium text-gray-900 text-lg">
                            {item.productName || `Product #${item.productid}`}
                          </div>
                        </td>
                        <td className="p-4 text-center">
                          <span className="bg-blue-100 text-blue-800 px-4 py-2 rounded-full text-sm font-bold">
                            {item.quantity}
                          </span>
                        </td>
                        <td className="p-4 text-right font-medium text-gray-900 text-lg">
                          PKR {item.price?.toFixed(0) || "0"}
                        </td>
                        <td className="p-4 text-right font-bold text-green-600 text-lg">
                          PKR {item.total?.toFixed(0) || "0"}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </CardContent>
          </Card>

          {/* Payment Details */}
          <Card className="shadow-xl border-0">
            <CardHeader className="bg-gradient-to-r from-blue-500 to-blue-600 text-white rounded-t-lg">
              <h2 className="text-lg font-semibold flex items-center gap-2">
                <Icon icon="heroicons:credit-card" width={20} height={20} />
                Payment Details
              </h2>
            </CardHeader>
            <CardContent className="p-0">
              <div className="overflow-x-auto">
                <table className="w-full">
                  <thead className="bg-gray-100">
                    <tr>
                      <th className="text-center p-4 font-semibold text-gray-700 border-b">
                        Payment Type
                      </th>
                      <th className="text-center p-4 font-semibold text-gray-700 border-b">
                        Account Name
                      </th>
                      <th className="text-center p-4 font-semibold text-gray-700 border-b">
                        Payment Status
                      </th>
                      <th className="text-center p-4 font-semibold text-gray-700 border-b">
                        Amount
                      </th>
                      <th className="text-center p-4 font-semibold text-gray-700 border-b">
                        Received By
                      </th>
                      <th className="text-center p-4 font-semibold text-gray-700 border-b">
                        Receipt
                      </th>
                      <th className="text-center p-4 font-semibold text-gray-700 border-b">
                        Action
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200">
                    {transactionLogs && transactionLogs
                      .filter(x => x.transactionType !== TransactionLogTypeEnum.PromoCode_Redeemed &&
                        x.transactionType !== TransactionLogTypeEnum.Club_Discount &&
                        x.transactionType !== TransactionLogTypeEnum.Bank_Discount)
                      .length > 0 ? (
                      transactionLogs
                        .filter(x => x.transactionType !== TransactionLogTypeEnum.PromoCode_Redeemed &&
                          x.transactionType !== TransactionLogTypeEnum.Club_Discount &&
                          x.transactionType !== TransactionLogTypeEnum.Bank_Discount)
                        .map((tlog, index) => (
                          <tr key={index} className="hover:bg-gray-50 transition-colors">
                            <td className="text-center p-4 border-b">
                              {tlog?.pfr_PaymentName || Common.Utility.getKeyByValue(PaymentTypeEnum, tlog?.paymentTypeId) || "-"}
                            </td>
                            <td className="text-center p-4 border-b">
                              {tlog?.clubAccountName || "-"}
                            </td>
                            <td className="text-center p-4 border-b">
                              <span className={`px-3 py-1 rounded-full text-sm font-medium ${tlog.status === TransactionLogStatusEnum.Success ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
                                }`}>
                                {Common.Utility.getKeyByValue(TransactionLogStatusEnum, tlog.status)}
                              </span>
                            </td>
                            <td className="text-center p-4 border-b font-semibold">
                              PKR {tlog.amount?.toFixed(0) || "0"}
                            </td>
                            <td className="text-center p-4 border-b font-semibold">
                              {tlog?.createdByName || "-"}
                            </td>
                            <td className="text-center p-4 border-b">
                              {/* {tlog.attachment ? (
                                 <img
                                   src={Common.Utility.getImagePath(tlog.attachment)}
                                   alt="Receipt"
                                   className="cursor-pointer rounded mx-auto"
                                   style={{ width: "50px", height: "50px" }}
                                   onClick={() => handleImageClick(tlog.attachment)}
                                 />
                               ) : (
                                 "-"
                               )} */}
                              {tlog.attachment ? (
                                <div className="relative inline-block">
                                  <img
                                    src={Common.Utility.getImagePath(tlog.attachment)}
                                    alt="Attachment"
                                    className="cursor-pointer rounded border"
                                    style={{ width: "50px", height: "50px" }}
                                    onClick={() => handleImageClick(tlog.attachment)}
                                  />
                                  <FaRedo
                                    className="absolute -top-1 -right-1 text-blue-500 cursor-pointer bg-white rounded-full shadow-md hover:bg-blue-50 transition-colors receipt-reupload-icon"
                                    onClick={() => handleUpdateReceipt(tlog)}
                                  />
                                </div>
                              ) : (
                                "-"
                              )}
                            </td>
                            <td className="text-center p-4 border-b">
                              {tlog.attachmenthistorylogs.length > 0 ? (
                                <div className="flex items-center justify-center gap-2">

                                  <FaEye
                                    className="text-blue-500 cursor-pointer ml-2"
                                    onClick={() => {
                                      handleSeeLog(tlog)
                                    }}
                                  />

                                </div>
                              ) : (
                                "-"
                              )}
                            </td>
                          </tr>
                        ))
                    ) : (
                      <tr>
                        <td colSpan={6} className="text-center p-8 text-gray-500">
                          No payment transactions found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </CardContent>
          </Card>

          {/* Discount Details */}
            <Card className="shadow-xl border-0">
              <CardHeader className="bg-gradient-to-r from-purple-500 to-purple-600 text-white rounded-t-lg">
                <h2 className="text-lg font-semibold flex items-center gap-2">
                  <Icon icon="heroicons:tag" width={20} height={20} />
                  Discount Details
                </h2>
              </CardHeader>
              <CardContent className="p-0">
                <div className="overflow-x-auto">
                  <table className="w-full">
                    <thead className="bg-gray-100">
                      <tr>
                        <th className="text-center p-4 font-semibold text-gray-700 border-b">
                          Type
                        </th>
                        <th className="text-center p-4 font-semibold text-gray-700 border-b">
                          Promo Code
                        </th>
                        <th className="text-center p-4 font-semibold text-gray-700 border-b">
                          Discount Amount
                        </th>
                        <th className="text-center p-4 font-semibold text-gray-700 border-b">
                          Capped
                        </th>
                        <th className="text-center p-4 font-semibold text-gray-700 border-b">
                          Receipt
                        </th>
                        <th className="text-center p-4 font-semibold text-gray-700 border-b">
                          Action
                        </th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-200">
                      {transactionLogs && transactionLogs.filter(x =>
                        x.transactionType === TransactionLogTypeEnum.PromoCode_Redeemed ||
                        x.transactionType === TransactionLogTypeEnum.Club_Discount ||
                        x.transactionType === TransactionLogTypeEnum.Bank_Discount
                      ).length > 0 ? (
                        transactionLogs
                          .filter(x => x.transactionType === TransactionLogTypeEnum.PromoCode_Redeemed ||
                            x.transactionType === TransactionLogTypeEnum.Club_Discount ||
                            x.transactionType === TransactionLogTypeEnum.Bank_Discount)
                          .map((tlog, index) => (
                            <tr key={index} className="hover:bg-gray-50 transition-colors">
                              <td className="text-center p-4 border-b">
                                {Common.Utility.getKeyByValue(TransactionLogTypeEnum, tlog.transactionType)}
                              </td>
                              <td className="text-center p-4 border-b">
                                {tlog?._promocode || "-"}
                              </td>
                              <td className="text-center p-4 border-b font-semibold text-red-600">
                                 {tlog?.promocodeAmt?.toFixed(0) || "0"}
                              </td>
                              <td className="text-center p-4 border-b">
                                <span className={`px-3 py-1 rounded-full text-sm font-medium ${tlog.isCapped ? 'bg-yellow-100 text-yellow-800' : 'bg-gray-100 text-gray-800'
                                  }`}>
                                  {tlog.isCapped ? "Yes" : "No"}
                                </span>
                              </td>
                              <td className="text-center p-4 border-b">
                                {/* {tlog.attachment ? (
                                  <img
                                    src={Common.Utility.getImagePath(tlog.attachment)}
                                    alt="Receipt"
                                    className="cursor-pointer rounded mx-auto"
                                    style={{ width: "50px", height: "50px" }}
                                    onClick={() => handleImageClick(tlog.attachment)}
                                  />
                                ) : (
                                  "-"
                                )} */}
                                {tlog.attachment ? (
                                <div className="relative inline-block">
                                  <img
                                    src={Common.Utility.getImagePath(tlog.attachment)}
                                    alt="Attachment"
                                    className="cursor-pointer rounded border"
                                    style={{ width: "50px", height: "50px" }}
                                    onClick={() => handleImageClick(tlog.attachment)}
                                  />
                                  <FaRedo
                                    className="absolute -top-1 -right-1 text-blue-500 cursor-pointer bg-white rounded-full shadow-md hover:bg-blue-50 transition-colors receipt-reupload-icon"
                                    onClick={() => handleUpdateReceipt(tlog)}
                                  />
                                </div>
                              ) : (
                                "-"
                              )}
                            </td>
                            <td className="text-center p-4 border-b">
                              {tlog.attachmenthistorylogs.length > 0 ? (
                                <div className="flex items-center justify-center gap-2">

                                  <FaEye
                                    className="text-blue-500 cursor-pointer ml-2"
                                    onClick={() => {
                                      handleSeeLog(tlog)
                                    }}
                                  />

                                </div>
                              ) : (
                                "-"
                              )}
                              </td>
                            </tr>
                          ))
                      ) : (
                        <tr>
                          <td colSpan={5} className="text-center p-8 text-gray-500">
                            No discount transactions found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </CardContent>
            </Card>
        </div>

        {/* Sidebar - Payment Summary */}
        <div className="xl:col-span-1">
          <Card className="shadow-xl border-0">
            <CardHeader className="bg-gradient-to-r from-green-500 to-green-600 text-white rounded-t-lg">
              <h2 className="text-lg font-semibold flex items-center gap-2">
                <Icon icon="heroicons:currency-dollar" width={20} height={20} />
                Payment Summary
              </h2>
            </CardHeader>
            <CardContent className="p-6">
              <div className="space-y-4">
                <div className="flex justify-between items-center p-4 bg-gray-50 rounded-lg border">
                  <span className="text-gray-600 font-medium">Subtotal</span>
                  <span className="font-bold text-gray-900 text-lg">
                    PKR {order.total_amount?.toFixed(0) || "0"}
                  </span>
                </div>

                {order.discount > 0 && (
                  <div className="flex justify-between items-center p-4 bg-red-50 rounded-lg border border-red-200">
                    <span className="text-red-600 font-medium">Discount</span>
                    <span className="font-bold text-red-600 text-lg">
                      PKR {order.discount?.toFixed(0)}
                    </span>
                  </div>
                )}

                <div className="border-t-2 pt-4">
                  <div className="flex justify-between items-center p-5 bg-gradient-to-r from-blue-50 to-blue-100 rounded-lg border-2 border-blue-200">
                    <span className="text-xl font-bold text-blue-900">
                      Net Total
                    </span>
                    <span className="text-2xl font-bold text-blue-600">
                      PKR {order.net_amount?.toFixed(0) || "0"}
                    </span>
                  </div>
                </div>

                <div className="space-y-3">
                  <div className="flex justify-between items-center p-4 bg-green-50 rounded-lg border border-green-200">
                    <span className="text-green-700 font-medium">
                      Received Amount
                    </span>
                    <span className="font-bold text-green-600 text-lg">
                      PKR {order.received_amount?.toFixed(0) || "0"}
                    </span>
                  </div>

                  <div className="flex justify-between items-center p-4 bg-gray-50 rounded-lg border">
                    <span className="text-gray-700 font-medium">
                      Payment Status
                    </span>
                    <span
                      className={`px-4 py-2 rounded-full text-sm font-medium ${paymentStatus.className}`}
                    >
                      {paymentStatus.label}
                    </span>
                  </div>

                  {order.remaining_amount > 0 && (
                    <div className="flex justify-between items-center p-4 bg-yellow-50 rounded-lg border border-yellow-200">
                      <span className="text-yellow-700 font-medium">
                        Remaining Amount
                      </span>
                      <span className="font-bold text-yellow-600 text-lg">
                        PKR {order.remaining_amount?.toFixed(0)}
                      </span>
                    </div>
                  )}
                </div>
              </div>
            </CardContent>
          </Card>

          {/* Quick Actions */}
          <Card className="mt-6 shadow-xl border-0">
            <CardHeader className="bg-gradient-to-r from-gray-700 to-gray-800 text-white rounded-t-lg">
              <h2 className="text-lg font-semibold">Quick Actions</h2>
            </CardHeader>
            <CardContent className="p-6">
              <div className="space-y-3">
                {order?.cancelled_by == null && (
                  <Button
                    onClick={handlePrint}
                    className="w-full bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 shadow-lg hover:shadow-xl transition-all"
                    size="lg"
                  >
                    <Icon icon="heroicons:printer" className="h-5 w-5 mr-2" />
                    Print Receipt
                  </Button>
                )}
                <Button
                  variant="outline"
                  onClick={() => navigate("/app/pos")}
                  className="w-full bg-white shadow-md hover:shadow-lg transition-all"
                  size="lg"
                >
                  <Icon icon="heroicons:plus" className="h-5 w-5 mr-2" />
                  New Order
                </Button>
                <Button
                  variant="outline"
                  onClick={() => navigate("/app/pos-orders")}
                  className="w-full bg-white shadow-md hover:shadow-lg transition-all"
                  size="lg"
                >
                  <Icon icon="heroicons:list-bullet" className="h-5 w-5 mr-2" />
                  All Orders
                </Button>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>

      {/* Hidden Print Component */}
      <div style={{ display: "none" }}>
        <PrintReceipt
          title={global?.myClub?.name}
          subtitle="POS Order Receipt"
          ref={printRef}
          data={{
            "Order Number": order.ref_no,
            "Order Date": order.createdon
              ? Common.Utility.ConvertTime(order.createdon)
              : "N/A",
            Customer: order.customerName || "Walk-in Customer",
            "Payment Status": getPaymentStatusDisplay(order.payment_status)
              .label,
            "Order Status": getOrderStatusDisplay(order.status).label,
            "---": "---",
            Subtotal: `PKR ${order.total_amount?.toFixed(0) || "0"}`,
            ...(order.discount > 0
              ? { Discount: `PKR ${order.discount?.toFixed(0)}` }
              : {}),
            "Net Total": `PKR ${order.net_amount?.toFixed(0) || "0"}`,
            "Received Amount": `PKR ${order.received_amount?.toFixed(0) || "0"
              }`,
            ...(order.remaining_amount > 0
              ? {
                "Remaining Amount": `PKR ${order.remaining_amount?.toFixed(
                  0
                )}`,
              }
              : {}),
            "----": "----",
            ITEMS: "ITEMS",
            ...(order.items?.reduce((acc, item, index) => {
              acc[`${item.productName || `Product #${item.productid}`}`] = `${item.quantity
                } x PKR ${item.price?.toFixed(0)} = PKR ${item.total?.toFixed(
                  0
                )}`;
              return acc;
            }, {}) || {}),
            // ...(order.note ? { "Notes": order.note } : {})
          }}

        // subtitle="POS Order Receipt"
        />
      </div>
      {/* </div>
  ); */}
      {/* Image Modal */}
      {isModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white p-5 rounded-lg shadow-lg relative max-w-3xl w-[90%] h-auto">
            <button
              onClick={closeModal}
              className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
            >
              <Icon icon="heroicons:x-mark" className="w-6 h-6" />
            </button>
            <h2 className="text-lg font-bold mb-4 text-center">Receipt</h2>
            <div className="flex justify-center items-center min-h-[200px]">
              {modalContent && (
                <img
                  src={modalContent.props.src}
                  alt="Receipt"
                  className="max-w-full max-h-[70vh] object-contain rounded-lg"
                  style={{ margin: 'auto' }}
                />
              )}
            </div>
          </div>
        </div>
      )}


      {/* DialogModal for updating receipt */}
      {showUpdateReceipt && (
        <DialogModal
          title={
            <div className="flex items-center gap-3">
              <div className="bg-blue-100 p-2 rounded-lg">
                <Icon
                  icon="heroicons:document-arrow-up"
                  className="w-5 h-5 text-blue-600"
                />
              </div>
              <div>
                <h3 className="font-semibold text-lg">Update Receipt</h3>
                <p className="text-gray-600 text-sm">
                  Upload new receipt or change existing one
                </p>
              </div>
            </div>
          }
          open={showUpdateReceipt}
          setOpen={setShowUpdateReceipt}
          Child={() =>
            _renderUpdateReceipt({
              ...updateReceiptData,
              onClose: () => setShowUpdateReceipt(false),
            })
          }
          className="max-w-2xl max-h-[90vh]"
        />
      )}

      {/* Modal for seeing log */}
      {showLogModal && (
        <DialogModal
          open={showLogModal}
          setOpen={setShowLogModal}
          Child={() =>
            _renderViewLogs({
              logs: selectedLog?.attachmenthistorylogs || [],
              onClose: () => setShowLogModal(false),
            })
          }
          className="!max-w-6xl w-[90vw] max-h-[90vh]"
        />
      )}

      {/* Hidden Print Component */}
      <div style={{ display: "none" }}>
        <POSReceipt
          ref={printRef}
          order={order}
          title={global?.myClub?.name}
          subtitle="POS Order Receipt"
          showPrintButton={false}
        />
      </div>







    </div>
  );
};

export default POSOrderDetails;



